"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TODAYS_STORE_HOURS = exports.TODAYS_PICK_UP_HOURS = exports.TODAYS_DELIVERY_HOURS = exports.SEARCH_DELIVER_LOCATIONS_MESSAGE = exports.PICK_UP_SUGGESTION_MESSAGE = exports.NO_PICKUP_TEXT = exports.NO_LOCATIONS_TO_DELIVER_MESSAGE = exports.NO_DELIVERY_TEXT = exports.ADDRESS_HEADER_TEXT = void 0; // Type 1 Component

var NO_LOCATIONS_TO_DELIVER_MESSAGE = "\nNo locations deliver to \nyour address";
exports.NO_LOCATIONS_TO_DELIVER_MESSAGE = NO_LOCATIONS_TO_DELIVER_MESSAGE;
var PICK_UP_SUGGESTION_MESSAGE = "But there’s always pick-up";
exports.PICK_UP_SUGGESTION_MESSAGE = PICK_UP_SUGGESTION_MESSAGE;
var SEARCH_DELIVER_LOCATIONS_MESSAGE = "Search to see which locations deliver to your address"; // Locations Map

exports.SEARCH_DELIVER_LOCATIONS_MESSAGE = SEARCH_DELIVER_LOCATIONS_MESSAGE;
var TODAYS_DELIVERY_HOURS = "Today's Delivery Hours";
exports.TODAYS_DELIVERY_HOURS = TODAYS_DELIVERY_HOURS;
var TODAYS_PICK_UP_HOURS = "Today's Pickup Hours";
exports.TODAYS_PICK_UP_HOURS = TODAYS_PICK_UP_HOURS;
var TODAYS_STORE_HOURS = "Today's Store Hours";
exports.TODAYS_STORE_HOURS = TODAYS_STORE_HOURS;
var NO_DELIVERY_TEXT = " No Delivery";
exports.NO_DELIVERY_TEXT = NO_DELIVERY_TEXT;
var NO_PICKUP_TEXT = " No Pickup";
exports.NO_PICKUP_TEXT = NO_PICKUP_TEXT;
var ADDRESS_HEADER_TEXT = "Address";
exports.ADDRESS_HEADER_TEXT = ADDRESS_HEADER_TEXT;
var _default = {
  NO_LOCATIONS_TO_DELIVER_MESSAGE: NO_LOCATIONS_TO_DELIVER_MESSAGE,
  PICK_UP_SUGGESTION_MESSAGE: PICK_UP_SUGGESTION_MESSAGE,
  SEARCH_DELIVER_LOCATIONS_MESSAGE: SEARCH_DELIVER_LOCATIONS_MESSAGE,
  TODAYS_DELIVERY_HOURS: TODAYS_DELIVERY_HOURS,
  TODAYS_PICK_UP_HOURS: TODAYS_PICK_UP_HOURS,
  TODAYS_STORE_HOURS: TODAYS_STORE_HOURS,
  NO_DELIVERY_TEXT: NO_DELIVERY_TEXT,
  NO_PICKUP_TEXT: NO_PICKUP_TEXT,
  ADDRESS_HEADER_TEXT: ADDRESS_HEADER_TEXT
};
exports["default"] = _default;